import React, { Component } from "react";
import { connect } from "react-redux";
import ThemeButton from '../../components/ThemeButton';
import { Fields, reduxForm , formValueSelector} from "redux-form";

import { getConservatoryStyles, updatePreviousSelection } from '../../actions';

import SelectSize from "./SelectSize";
import validate from "./validate";

import FormWrapper from "../FormWrapper";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";

class SizeForm extends Component {

    componentWillMount(){
        this.props.getConservatoryStyles(this.props.conservatoryId);
    }

    onSubmit = (values) => {
        this.props.updatePreviousSelection({
            ConservatorySizeWidth: values.ConservatorySize.Width,
            ConservatorySizeHeight: values.ConservatorySize.Height,
            ConservatorySizeUnit: values.ConservatorySize.Unit
        });
        this.props.onSubmit();
    }

    render() {
        const { loading, MinWidth, MaxWidth, MinHeight, MaxHeight, previousPage } = this.props;
        return (
            <form className="SizeForm" onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <FormHeader title={(loading? "Loading" :"Set your dimensions")} subtitle={""}/>
                <SeparatingLine />
                <FormWrapper>
                    <Fields
                        names={["ConservatorySize.Width", "ConservatorySize.Height", "ConservatorySize.Unit"]}
                        range={{ MinWidth, MaxWidth, MinHeight, MaxHeight }}
                        component={SelectSize}
                        loading={loading}
                    />
                </FormWrapper>
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("ConservatoryWizard");
    let modelMinWidths = state.Conservatory.Styles.map(model => model.minWidth);
    let modelMinHeights = state.Conservatory.Styles.map(model => model.minHeight);
    let modelMaxWidths = state.Conservatory.Styles.map(model => model.maxWidth);
    let modelMaxHeights = state.Conservatory.Styles.map(model => model.maxHeight);
    return {
        sizes: state.Conservatory.Sizes,
        conservatoryId: valueSelector(state, "ConservatoryId"),
        MinWidth: Math.min(...modelMinWidths),
        MinHeight: Math.min(...modelMinHeights),
        MaxWidth: Math.max(...modelMaxWidths),
        MaxHeight: Math.max(...modelMaxHeights),
        loading: modelMinWidths.length === 0 || modelMaxWidths.length === 0,        
        previousSelection: state.PreviousSelection
    };
    
};

export default connect(mapStateToProps, {getConservatoryStyles, updatePreviousSelection})(
    reduxForm({
    form: "ConservatoryWizard",
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    validate,
    initialValues: {
        ConservatorySize: {
            Unit: "m",
            Width: 0,
            Height: 0
        }
    }
})(SizeForm));


// WEBPACK FOOTER //
// ./src/containers/ConservatoryForm/SizeForm.js